<div class="content-card-list {{ classes }}">
  @for (card of cards; track card; let i = $index) {
    @if (card.__typename === 'FeaturedCard') {
      <sharry-featured-card
        [id]="'item-' + card.id"
        [data]="card"></sharry-featured-card>
    } @else {
      <sharry-content-card
        [card]="mode === 'sharryAttendance' ? card?.sharryInstance?.sharryContent : card"
        [class.content-card-list&#45;&#45;recommendation]="cardsType === 'recommendation'"
        [classes]="cardClasses"
        (bookmarkedChanged)="onChangedBookmarked($event)">
      </sharry-content-card>
    }
  }
</div>
